<template>
    <div class="headerMain">
        <img :src="leaveImg" alt="" class="leaveImg">
        <div class="text-container-header d-flex space-between vertical-center" ref="absElement">
            <div>
                <h2 class="headerMain-title" >{{ title }}</h2>
                <p class="headerMain-description">{{description}}</p>
            </div>
            <div class="info-img" v-if="modalActivator">
                <img :src="infoImg" @click="$emit('activateModal')" v-if="!modalActive" />
                <img :src="savoirPlusImg" @click="$emit('activateModal')" v-if="modalActive" />
            </div>
        </div>
        <div ref="followingElement"></div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            leaveImg:require('@/assets/images/feuille.png'),
            infoImg: require("@/assets/images/info.png"),
            savoirPlusImg: require("@/assets/images/ensavoirplus.png"),
        }
    },
    props:{
        title:String,
        description:{Type:String, Default:null},
        modalActivator: { type: Boolean, default: false },
        modalActive: { type: Boolean, default: false }
    },
    mounted() {
        this.adjustMargin();
    },
    methods: {
        adjustMargin() {
            const absElement = this.$refs.absElement;
            const followingElement = this.$refs.followingElement;

            if (absElement && followingElement) {
                const rect = absElement.getBoundingClientRect();
                followingElement.style.marginTop = `${rect.height/4*2}px`;
            }
        }
    }
}
</script>
<style scoped>
.headerMain{
    width:85%;
    margin-left:auto;
    margin-right:auto;
    position:relative;
    height: auto;
    display: block;
}
.leaveImg{
    max-width:230px;
  }
.headerMain-title{
    color: var(--text-color);
    font-family: var(--font);
    font-size: 4.2rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.1em;
    margin:0;
}
.text-container-header{
    position:absolute;
    top:0%;
    left:110px;
    width:85%;
    height: 100%;
}
.text-container-header>div{
    top:35%;
}
.headerMain-description{
    color: var(--text-color);
    font-family: var(--font);
    font-size: 26px;
    font-style: normal;
    font-weight: 600;
    line-height: 1.1em; /* 127.692% */
    margin-top:0px;
}
.info-img {
        display:none;
    }
@media (hover: none) {
    .info-img {
        display:block;
    }
}
@media screen and (max-width: 600px) {
  .leaveImg{
    max-width:110px;
  }
  .headerMain-title{
    font-size: 3rem;
  }
  .text-container-header{
    left:55px;
  }
}
</style>